import { render, staticRenderFns } from "./ReportingSelect.vue?vue&type=template&id=6c1844c2&scoped=true&lang=pug&"
import script from "./ReportingSelect.vue?vue&type=script&lang=ts&"
export * from "./ReportingSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1844c2",
  null
  
)

export default component.exports